import { BundleStatusEnum } from '#types';
import { DocumentTypeEnum } from '../../../blocks/SuggestDocumentCreateModal';
import { createBundleObject } from './createBundleObject';

export const getIsLastDocumentInBundle = (
	documentType: DocumentTypeEnum,
	contactId?: string
) => {
	if ( contactId ) {
		const bundle = createBundleObject( contactId );
		if ( !bundle ) {
			/* if contactId exists, meaning that we're creating a bundle, yet createBundleObject returns null,
			then that tells us this is a one-document bundle, like two NotAwaiting values would also indicate */
			return true;
		} else {
			const makingContract =
				bundle.contractBundleStatus === BundleStatusEnum.Awaiting;
			const makingInvoice =
				bundle.invoiceBundleStatus === BundleStatusEnum.Awaiting;
			const makingProposal =
				bundle.proposalBundleStatus === BundleStatusEnum.Awaiting;
			return (
				( documentType === DocumentTypeEnum.Proposal &&
					!makingContract &&
					!makingInvoice ) ||
				( documentType === DocumentTypeEnum.Contract &&
					!makingInvoice &&
					!makingProposal ) ||
				( documentType === DocumentTypeEnum.Invoice &&
					!makingProposal &&
					!makingContract )
			);
		}
	}
	// if there's no contactId then we can't have a bundle, so there is no "last document"
	return false;
};
